import { memo } from "react";
import Image from "next/image";
import { FaStar } from "react-icons/fa";

const Google = memo(({ icon, title }) => {
  return (
    <div
      className={`flex flex-col gap-3 items-center justify-center text-center text-white `}
    >
      <Image
        src={icon}
        alt={title}
        width={141}
        height={70}
        className="object-contain"
      />

      <div className="flex flex-row items-start justify-start gap-1">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>
      <div className="leading-[140%] font-medium text-[24px] text-white m-0">
        {title}
      </div>
    </div>
  );
});

export default Google;
